<template>
  <div class="p-resolution">
    <section class="c-p-r about-banner">
      <div class="c-d-f c-fd-c c-ai-c c-ta-c c-c-white cm-width about-banner-desc">
        <p class="c-fs-38 c-mb-32 c-fw-b top-title">解决方案</p>
        <!-- <p class="c-fs-16 c-ff-l top-desc">报道企业最新消息，实时发布企业动向</p> -->
      </div>
    </section>
    <div class="cm-width c-c-text-grey resolution-wrap">
      <div class="c-mb-36 c-bc-white case-item" v-for="(item, index) in caseList" :key="index" @click="toUrl(item.url)">
        <div class="case-img">
          <img :src="item.img">
          <div class="c-plr-20 news-title-mask">
            <div class="c-c-white c-ellipsis">{{item.title}}</div>
          </div>
        </div>
        <div class="c-plr-20 c-pb-28 c-fs-14 c-c-text-grey">
          <p class="c-mt-16">———<span class="c-ml-8">{{item.date}}</span></p>
          <div class="c-lh-24 c-mt-16 c-c-text-black c-ta-j c-ellipsis">{{item.desc}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const caseList = [{
  id: 1,
  title: '证券行业解决方案',
  img: require('../assets/resolution/pic1.png'),
  date: '2019.09.12',
  desc: '证券行业的业务系统主要包括：行情发送系统、行情传送系统、行情接收系统、行情客户端系统、交易系统、结算系统和开户系统。这些系统需要24小时不间断的管理关于，单纯依靠人力手动运维，已经难以满足市场要求，时间紧张，容易认为出错，后果将难以估计。',
  url: '/resolution_case1'
}]
export default {
  name: 'resolution',
  data () {
    return {
      caseList: caseList
    }
  },
  methods: {
    toUrl (url) {
      if (url) {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style lang="scss">
.p-resolution {
  min-height: calc(100vh - 90px - 525px);
  .about-banner {
    height: 560px;
    background: url("../assets/support/support-banner.jpg") no-repeat;
    background-size: cover;
    background-position: bottom;
    @media screen and (max-width: $max-width-standard) {
      height: 232px;
      background: url("../assets/support/support-banner-m.jpg") no-repeat center / cover;
      .top-title {
        font-size: 19px;
        margin-bottom: 12px;
      }
      .top-desc {
        width: 70%;
        font-size: 9px;
        line-height: 16px;
        margin-bottom: 15px!important;
      }
    }
    .about-banner-desc {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .resolution-wrap {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 80px;
    margin-bottom: 160px;
    .case-item {
      width: calc((100% / 3) - 24px);
      position: relative;
      cursor: pointer;
      border-radius: 10px;
      transition: all 0.5s ease-in-out;
      overflow: hidden;
      border: 1px solid $border-color;
      &:hover {
        transform: translateY(-16px);
        box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.2);
        img {
          transform: scale(1.2);
        }
      }
      .case-img {
        height: 210px;
        position: relative;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: all 0.5s ease;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
        .news-title-mask {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 70px;
          display: flex;
          align-items: center;
          background: rgba(0, 0, 0, 0.3);
        }
      }
    }
    @media screen and (max-width: $max-width-standard) {
      display: block;
      margin-top: 40px;
      margin-bottom: 40px;
      .case-item {
        width: 100%;
      }
    }
  }
}
</style>
